import styled from 'styled-components';

export const TablePaginationWrapper = styled.div`
    display: flex;
    align-items: center;
    padding: .5rem;
    font-size: 13px;
    > * {
        padding: 0 5px;
    }
`;
